<tui-scrollbar class="registration-page">
  <app-registration [associationId]="associationId" (saved)="onSaveRegistrationUser()"></app-registration>
</tui-scrollbar>
